module.exports = __webpack_public_path__ + "static/media/employees.b47cc452.png";